export default __webpack_public_path__ + "static/media/elo.9c9c0eed.svg";